/** Footer row for auth CTAs — natural height, centered. */
export function AuthFormFooter({ children, testId }) {
    return (
        <p className="auth-form__footer" data-testid={testId}>
            {children}
        </p>
    );
}
